const viewBookingEN = {
	header: {
		title: "Booking Overview",
	},
	status: {
		confirmed: "Confirmed",
		cancelled: "Cancelled",
		in_progress: "In Progress",
		pending: "Pending",
	},
	details: {
		services: "Services:",
		staff: "Staff:",
		date: "Date:",
		time: "Time:",
		location: "Location",
	},
	sidebar: {
		location: "Location",
		getDirections: "Get Directions",
	},
	manage: {
		title: "Manage Booking",
		rescheduleInfo: "Reschedule your appointment",
		rescheduleBtn: "Reschedule",
		cancelBtn: "Cancel Booking",
		backBtn: "Back",
	},
	misc: {
		confirmationEmail: "A confirmation email was sent to",
		reviewSubmitted: "Thank you! Your review was successfully submitted.",
		reviewUpdated: "Review updated!",
	},
};
export default viewBookingEN;
